import { combineReducers } from "redux";
import AuthReducer from "../views/auth/reducer";
import UserReducer from "../views/users/reducer";
import CmsReducer from "../views/cms/reducer";
import SiteReducer from "../views/sites/reducer";
import ArticleReducer from "../views/articles/reducer";
import HowToVideosReducer from "../views/howToVideos/reducer";
import CityReducer from "../views/cities/reducer";
import ReportReducer from "../views/reportManager/reducer";
import FeedbackReducer from "../views/feedback/reducer";
import DashboardReducer from "../views/dashboard/reducer";
import QueriesReducer from "../views/queries/reducer";
import RatingsAndReviewsReducer from "../views/ratingsAndReviews/reducer";

/**
 * @description RootReducer and all child ruders
 */

const RootReducer = combineReducers({
  DashboardReducer,
  AuthReducer,
  UserReducer,
  CmsReducer,
  SiteReducer,
  ArticleReducer,
  HowToVideosReducer,
  CityReducer,
  ReportReducer,
  FeedbackReducer,
  QueriesReducer,
  RatingsAndReviewsReducer,
});

export default RootReducer;
